import { throttle } from 'lodash';
import EventEmitter from '../../../utility/event-emitter';
const VOLUME_STEP = 10;
const MINIMUM_VOLUME = 0.01;
const UPDATE_VOLUME_ONCE_AT = 100;
export class TokboxVolumeListener {
    constructor(subscriber) {
        this.subscriber = subscriber;
        this.volumeLevel = 0;
        this._events = new EventEmitter();
        this.movingAvg = null;
        this.subscribeToAudioUpdate();
    }
    get events() {
        return this._events;
    }
    subscribeToAudioUpdate() {
        const throttleUpdate = throttle((event) => {
            const volumeLevel = event.audioLevel < MINIMUM_VOLUME
                ? 0 // too quiet (silence or breathing), calculations are not required
                : Math.round(this.getVolumeLevel(event) / VOLUME_STEP) * VOLUME_STEP;
            if (volumeLevel === this.volumeLevel) {
                return;
            }
            this.volumeLevel = volumeLevel;
            this._events.emit('update', volumeLevel);
        }, UPDATE_VOLUME_ONCE_AT);
        this.subscriber.on('audioLevelUpdated', (event) => {
            throttleUpdate(event);
        });
    }
    getVolumeLevelChanges(event) {
        this.movingAvg =
            this.movingAvg === null || this.movingAvg <= event.audioLevel
                ? event.audioLevel
                : (this.movingAvg = 0.7 * this.movingAvg + 0.3 * event.audioLevel);
        // 1.5 scaling to map the -30 - 0 dBm range to [0,1]
        const logLevel = Math.log10(this.movingAvg) / 1.5 + 1;
        return Math.min(Math.max(logLevel, 0), 1);
    }
    getVolumeLevel(event) {
        return this.getVolumeLevelChanges(event) * 100;
    }
}
